import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import indicators from '@client/shared/js/indicators';
import shapes from '@client/shared/js/shapes';
import themeStyles from '@client/shared/styles/theme/theme-styles.scss';
import styles from './heroSection.scss';

class HeroSection extends PureComponent {
  onCtaClick = (event) => {
    event.preventDefault();
    this.props.history.push(this.props.ctaUrl);
  };

  render() {
    const {
      className,
      title,
      description,
      ctaText,
      imageUrl,
      graphicsHero,
      graphicsHeroMobile,
    } = this.props;

    return (
      <div
        className={
          className ? `${styles.heroSection} ${className}` : styles.heroSection
        }
        style={{ backgroundImage: `url(${imageUrl})` }}
      >
        <div className={styles.overlay} />

        <div className={styles.heroSectionContentContainer}>
          <div className={styles.contentContainer}>
            <img
              className={styles.shapeTopLeft}
              src={shapes.graphic_letters_x2}
              alt="Factuals graphic letters"
            />
            <div className={themeStyles.heroTextTitle}>{title}</div>
            <div className={`${themeStyles.leadParagraph} ${styles.text}`}>
              {description}
            </div>
            {ctaText && (
              <button
                type="button"
                className={`${themeStyles.btnPrimary} ${styles.ctaButton}`}
                onClick={this.onCtaClick}
              >
                <img
                  className={styles.buttonIcon}
                  src={indicators.arrow_black}
                />
                {ctaText}
              </button>
            )}
          </div>
        </div>
        <picture>
          <source media="(max-width: 768px)" srcSet={graphicsHeroMobile} />
          <img
            className={styles.shapeBottomRight}
            src={graphicsHero}
            alt="Factuals graphic header mobile"
          />
        </picture>
      </div>
    );
  }
}

HeroSection.propTypes = {
  history: PropTypes.object,
  className: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  ctaText: PropTypes.string,
  ctaUrl: PropTypes.string,
  imageUrl: PropTypes.string,
  graphicsHero: PropTypes.string,
  graphicsHeroMobile: PropTypes.string,
  shapeAdjustmentY: PropTypes.number,
};

export default withRouter(HeroSection);
